import { render, staticRenderFns } from "./SwitchingCentreSummary.vue?vue&type=template&id=0eb40054&"
import script from "./SwitchingCentreSummary.vue?vue&type=script&lang=js&"
export * from "./SwitchingCentreSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports